import { CommonModule } from '@angular/common';
import { Component, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IdentityService } from 'src/app/core/identity.service';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { map, Observable } from 'rxjs';
import { DelegationRestrictAccessComponent } from '../delegation-restrict-access/delegation-restrict-access.component';

@Component({
    selector: 'nova-delegation-empty-card',
    standalone: true,
    imports: [MatIconModule, CommonModule, DelegationRestrictAccessComponent],
    templateUrl: './delegation-empty-card.component.html',
    styleUrls: ['./delegation-empty-card.component.scss']
})
export class DelegationEmptyCardComponent {
    auth0NovaImpersonationSignal: Signal<boolean>;
    isChildProfile$: Observable<boolean>;

    constructor(
        private readonly _identityService: IdentityService,
        private readonly _ldFeatureManager: LDFeatureManager
    ) {
        this.auth0NovaImpersonationSignal = this._ldFeatureManager.isEnabledSignal(FeatureFlag.Auth0NovaImpersonation);
        this.isChildProfile$ = this._identityService.user$.pipe(
            map((user) => user.primary_user_key !== user.user_key && this.auth0NovaImpersonationSignal())
        );
    }
}
